import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportarFuncionariosExcel(lista = []) {

    const dados = lista.map(f => ({
        "Nome": f.nome || "",
        "Cargo": f.cargo || "",
        "Filial": f.filialNome || "",
        "CPF": f.cpf || "",
        "Celular": f.celular || "",
        "Email": f.email || "",

        "Código RH": f.codigo || "",
        "Código Trixlog": f.codigoTrixlog || "",
        "Código Control": f.codigoControl || "",

        "Usuário": f.usuarioNomeUsuario || "",
        "Usuário Email": f.usuarioEmail || "",

        "Ativo": f.ativo ? "SIM" : "NÃO",

        "Sincronizado Fortes":
            f.sincronizadoComFortes ? "SIM" : "NÃO",

        "Sincronizado Trixlog":
            f.sincronizadoComTrixlog ? "SIM" : "NÃO",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dados);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Funcionarios"
    );

    // largura colunas
    worksheet["!cols"] = [
        { wch: 35 },
        { wch: 25 },
        { wch: 20 },
        { wch: 18 },
        { wch: 18 },
        { wch: 35 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 25 },
        { wch: 30 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
    ];

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const fileData = new Blob(
        [excelBuffer],
        {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    );

    saveAs(
        fileData,
        `funcionarios_${new Date().getTime()}.xlsx`
    );
}